import React from 'react';
import { Link } from 'react-router-dom';
import { MdInfoOutline, MdWarningAmber, MdLock } from 'react-icons/md';
import { useLanguage } from '../i18n';

// Thin notice above the page content: only appears when something needs attention
// (trial ending soon, payment overdue, or the read-only state).
export default function SubscriptionBanner({ status }) {
    const { t } = useLanguage();
    if (!status) return null;

    let tone = null;
    let text = '';
    if (status.state === 'trialing' && status.days_left != null && status.days_left <= 7) {
        tone = { bg: '#dbeafe', color: '#1e40af', icon: <MdInfoOutline /> };
        text = t('billing.bannerTrial', '', { days: status.days_left });
    } else if (status.state === 'grace') {
        tone = { bg: '#fef3c7', color: '#92400e', icon: <MdWarningAmber /> };
        text = t('billing.bannerGrace', '', { days: status.grace_days_left });
    } else if (status.state === 'read_only') {
        tone = { bg: '#fee2e2', color: '#991b1b', icon: <MdLock /> };
        text = t('billing.bannerReadOnly');
    }
    if (!tone) return null;

    return (
        <div role="status" style={{
            background: tone.bg, color: tone.color, borderRadius: 10, padding: '10px 14px', marginBottom: 16,
            display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', fontSize: 14, fontWeight: 600
        }}>
            {tone.icon}
            <span style={{ flex: 1 }}>{text}</span>
            {status.can_manage
                ? <Link to="/app/billing" style={{ color: tone.color, textDecoration: 'underline' }}>{t('billing.bannerAction')}</Link>
                : status.state !== 'trialing' && <span style={{ fontWeight: 500 }}>{t('billing.bannerAskAdmin')}</span>}
        </div>
    );
}
